export default __webpack_public_path__ + "static/media/background.c4123cb3.jpg";